<template>
    <div class="invoice-result">
        <div v-if="(invoicedata.ptype == 2) || (alldefault)" class="invoice-data">
            <div v-if="(invoicedata.failed == 1) || (alldefault)">
                <div class="central-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="160px" height="160px"><path fill="#f78f8f" d="M15,28.5C7.556,28.5,1.5,22.444,1.5,15S7.556,1.5,15,1.5S28.5,7.556,28.5,15S22.444,28.5,15,28.5z"/><path fill="#c74343" d="M15,2c7.168,0,13,5.832,13,13s-5.832,13-13,13S2,22.168,2,15S7.832,2,15,2 M15,1 C7.268,1,1,7.268,1,15s6.268,14,14,14s14-6.268,14-14S22.732,1,15,1L15,1z"/><path fill="#fff" d="M14 8H16V22H14z" transform="rotate(134.999 15 15)"/><path fill="#fff" d="M14 8H16V22H14z" transform="rotate(-134.999 15 15)"/></svg>
                </div>
                <h1>Уже вернулись?</h1>
                <h3>Похоже что-то пошло не по плану...<br>Что дальше?</h3>
                <div class="invoice-actions">
                    <button class="spin-button" @click="dropall">Отменить заказ</button>
                    <button class="spin-button" v-if="cart.length > 0" @click="$emit('goto', 'menu-page')">Изменить содержимое заказа</button>
                    <button class="spin-button" v-if="cart.length > 0" @click="$emit('goto', 'validate-order')">Изменить данные заказа</button>
                </div>
            </div>
            <div v-else-if="invoicedata.paid_amount == 0">
                <h1>Ожидание оплаты</h1>
                <h3>Мы ожидаем поступление вашей оплаты.<br>Обычно это не занимает более минуты, попробуйте обновить страницу чуть позже.</h3>
                <div class="invoice-actions">
                    <button class="spin-button" @click="tryagain">Обновить</button>
                </div>
            </div>
        </div>
        <div v-if="showInvoice" class="invoice-data">
            <div v-if="invoicedata.processed == 2" class="invoice-notprocessed">
                <div class="central-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="160px" height="160px"><path fill="#f78f8f" d="M15,28.5C7.556,28.5,1.5,22.444,1.5,15S7.556,1.5,15,1.5S28.5,7.556,28.5,15S22.444,28.5,15,28.5z"/><path fill="#c74343" d="M15,2c7.168,0,13,5.832,13,13s-5.832,13-13,13S2,22.168,2,15S7.832,2,15,2 M15,1 C7.268,1,1,7.268,1,15s6.268,14,14,14s14-6.268,14-14S22.732,1,15,1L15,1z"/><path fill="#fff" d="M14 8H16V22H14z" transform="rotate(134.999 15 15)"/><path fill="#fff" d="M14 8H16V22H14z" transform="rotate(-134.999 15 15)"/></svg>
                </div>
                <h1>Возникла ошибка!</h1>
                <h3>Не удалось отправить заказ в ресторан! <br>Пожалуйста, сделайте скриншот этого сообщения и свяжитесь с рестораном для получения дальнейших инструкций.</h3>
                <hr>
                <h4>crc: {{ invoicedata.crc }} </h4>
                <h4> {{ invoicedata.processerror }} </h4>
                <hr>
                <div class="invoice-actions">
                    <button class="spin-button" @click="dropall">На главную</button>
                </div>
            </div>
            <div v-else-if="invoicedata.processed == 1">
                <div class="central-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="160px" height="160px"><path fill="#bae0bd" d="M15,28.5C7.6,28.5,1.5,22.4,1.5,15S7.6,1.5,15,1.5S28.5,7.6,28.5,15S22.4,28.5,15,28.5z"/><path fill="#5e9c76" d="M15,2c7.2,0,13,5.8,13,13s-5.8,13-13,13S2,22.2,2,15S7.8,2,15,2 M15,1C7.3,1,1,7.3,1,15 s6.3,14,14,14s14-6.3,14-14S22.7,1,15,1L15,1z"/><path fill="#fff" d="M13 20.4L8.3 15.7 9.7 14.3 13 17.6 21.3 9.3 22.7 10.7z"/></svg>
                </div>
                <h1>Ваш заказ оформлен!</h1>
                <h2>Заказ передан в ресторан и будет доставлен в ближайшее время!</h2>
                <div class="invoice-actions">
                    <button class="spin-button" @click="dropall">На главную</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['invoicedata', 'cart'],
    computed:{
        showInvoice(){
            return (
                (
                    (this.invoicedata.ptype == 2)
                    && 
                    (this.invoicedata.paid_amount > 0)
                )
                || 
                (
                    (this.alldefault == false)
                )
            )
        },
        alldefault(){
            return ((this.invoicedata.failed == 0) && (this.invoicedata.paid_amount == 0) && (this.invoicedata.processed == 0))
        }
    },
    methods:{
        tryagain(){
            window.location.reload(true)
        },
        dropall(){
            sessionStorage.removeItem('minideliveryinvoice')
            sessionStorage.removeItem('minideliveryshopid')
            sessionStorage.removeItem('minideliverycart')
            this.tryagain()
        },
        getOffsetSum(elem) {
            var top=0, left=0
            while(elem) {
                top = top + parseFloat(elem.offsetTop)
                left = left + parseFloat(elem.offsetLeft)
                elem = elem.offsetParent       
            }
            return {top: Math.round(top), left: Math.round(left)}
        }
    },
    mounted(){
        window.scrollTo({top: this.getOffsetSum(document.getElementById('minidelivery')).top})
    }
}
</script>